/**
 * InfinitSales - Tags do Contato Service
 *
 * Tags = marcadores múltiplos por contato, criáveis na hora (separados das
 * etiquetas/Kanban). Catálogo no workspace + atribuição por contato.
 */
import api from './api';
import { isOpaqueKey } from '../../utils/channels';

// Chave do contato para a URL. Telefone vira so digitos; chave OPACA de
// Instagram/Messenger ('instagram:{igsid}' / 'messenger:{psid}') viaja
// intacta e codificada: apagar o prefixo aqui gravava tags, comentarios e
// campos numa chave indistinguivel de telefone (arquitetura empresarial,
// fase 1, mapa G). A canonizacao e sempre do servidor.
const sanitizePhone = (phone) => {
  if (!phone) return '';
  const raw = String(phone).trim();
  // O mapa de canais conhece os prefixos opacos (instagram:, messenger:,
  // widget:); um regex escrito a mao deixou o widget virar digitos (23/09).
  if (isOpaqueKey(raw)) return encodeURIComponent(raw);
  return raw.replace(/\D/g, '');
};

const contactTagsService = {
  // ---- Catálogo ----
  async listTags() {
    const res = await api.get('/api/contact-tags');
    return res.data?.data || [];
  },

  async createTag(name, color) {
    const res = await api.post('/api/contact-tags', { name, color });
    return res.data?.data;
  },

  async renameTag(tagId, patch) {
    const res = await api.patch(`/api/contact-tags/${tagId}`, patch);
    return res.data?.data;
  },

  async deleteTag(tagId) {
    const res = await api.delete(`/api/contact-tags/${tagId}`);
    return res.data?.data;
  },

  // ---- Por contato ----
  async getContactTags(phone) {
    const res = await api.get(`/api/contact-tags/contacts/${sanitizePhone(phone)}`);
    return res.data?.data || [];
  },

  async setContactTags(phone, tagIds) {
    const res = await api.put(`/api/contact-tags/contacts/${sanitizePhone(phone)}`, { tag_ids: tagIds });
    return res.data?.data;
  },
};

export default contactTagsService;
